import React from 'react';
import DropdownList from '../../FormElements/DropdownList';
import Tabs from '../../Tabs/Tabs';
import BarChart from '../../Charts/BarChart';
import DataSummary from '../../Charts/DataSummary';

export default function PropertyMetricsCard(props) {
	return (
		<div className="PropertyMetricsCard bg-white w-full min-w-96 mt-4 p-5 rounded-md shadow border text-gray-800 text-sm lg:text-base">
			<div className="grid lg:grid-cols-12 lg:gap-5">
				<div className="col-span-12 lg:col-span-2">
					<h2 className="text-lg lg:text-xl font-semibold mb-2">Metrics</h2>
					<DropdownList
						label="Date Range"
						displayLabel={false}
						// onChange={this.onChange}
						id="dateRange"
						name="dateRange"
						// value={this.state.dateRange}
						data={[
							{
								id: 1,
								name: 'YTD'
							},
							{
								id: 2,
								name: 'Last Month'
							},
							{
								id: 3,
								name: 'Last 3 Months'
							},
							{
								id: 4,
								name: 'Last 6 Months'
							},
							{
								id: 5,
								name: 'Last 12 Months'
							},
							{
								id: 6,
								name: 'Last Year'
							}
						]}
					/>
				</div>
				<div className="col-span-12 lg:col-span-6">
					<Tabs>
						<div label="Direct">
							<div className="md:ml-12 md:mt-10">
								<BarChart
									data={{
										yAxis: [
											0,
											2500,
											5000,
											7500,
											10000
										],
										data: [
											{
												name: 'Gross Revenue',
												value: 3412.45,
												color: '#4BC818'
											},
											{
												name: ' Taxable Revenue',
												value: 3101.48,
												color: '#E1E630'
											},
											{
												name: 'Taxes Paid',
												value: 404.65,
												color: '#E9A227'
											}
										]
									}}
								/>
							</div>
						</div>
						<div label="Airbnb">
							<div className="md:ml-12 md:mt-10">
								<BarChart
									data={{
										yAxis: [
											0,
											2500,
											5000,
											7500,
											10000
										],
										data: [
											{
												name: 'Gross Revenue',
												value: 1824.56,
												color: '#4BC818'
											},
											{
												name: ' Taxable Revenue',
												value: 1824.56,
												color: '#E1E630'
											},
											{
												name: 'Taxes Paid',
												value: 384.65,
												color: '#E9A227'
											}
										]
									}}
								/>
							</div>
						</div>
						<div label="Vrbo">
							<div className="md:ml-12 md:mt-10">
								<BarChart
									data={{
										yAxis: [
											0,
											2500,
											5000,
											7500,
											10000
										],
										data: [
											{
												name: 'Gross Revenue',
												value: 3465.42,
												color: '#4BC818'
											},
											{
												name: ' Taxable Revenue',
												value: 3465.42,
												color: '#E1E630'
											},
											{
												name: 'Taxes Paid',
												value: 750.54,
												color: '#E9A227'
											}
										]
									}}
								/>
							</div>
						</div>
						<div label="Total" isTextBold={true}>
							<div className="md:ml-12 md:mt-10">
								<BarChart
									data={{
										yAxis: [
											0,
											2500,
											5000,
											7500,
											10000
										],
										data: [
											{
												name: 'Gross Revenue',
												value: 7964.42,
												color: '#4BC818'
											},
											{
												name: ' Taxable Revenue',
												value: 6745.87,
												color: '#E1E630'
											},
											{
												name: 'Taxes Paid',
												value: 1625.42,
												color: '#E9A227'
											}
										]
									}}
								/>
							</div>
						</div>
					</Tabs>
				</div>
				<div className="col-span-12 lg:col-span-4">
					<DataSummary
						data={[
							{
								name: 'Direct # of Nights Rented',
								value: 6
							},
							{
								name: 'Airbnb # of Nights Rented',
								value: 8
							},
							{
								name: 'Vrbo # of Nights Rented',
								value: 12
							},
							{
								name: 'Total # of Nights Rented',
								value: 26
							}
						]}
					/>
				</div>
			</div>
		</div>
	);
}
